import { captureException } from '@sentry/react';

export const handleException = ({ error }: { error: Error }) => {
	console.error(error);
	captureException(error);
};
